(() => {
  document.querySelectorAll("[data-slideshow]").forEach((root) => {
    const track = root.querySelector("[data-slideshow-track]");
    const slides = [...root.querySelectorAll(".slideshow-slide")];
    const dots = [...root.querySelectorAll("[data-slideshow-dot]")];
    const pauseBtn = root.querySelector("[data-slideshow-pause]");
    const pauseIcon = pauseBtn?.querySelector("[data-pause-icon]");
    if (!track || slides.length < 2) return;

    let index = 0;
    const intervalMs = Number(root.dataset.interval) || 6000;
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let timer = 0;
    let paused = reduceMotion;

    function goTo(next) {
      index = (next + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      slides.forEach((slide, i) => slide.setAttribute("aria-hidden", i === index ? "false" : "true"));
      dots.forEach((dot, i) => dot.classList.toggle("is-active", i === index));
    }

    function syncPause() {
      if (!pauseBtn) return;
      pauseBtn.setAttribute("aria-pressed", paused ? "true" : "false");
      pauseBtn.setAttribute("aria-label", paused ? "Play slideshow" : "Pause slideshow");
      if (pauseIcon) pauseIcon.textContent = paused ? "▶" : "❚❚";
    }

    function play() {
      if (paused || reduceMotion) return;
      stop();
      timer = window.setInterval(() => goTo(index + 1), intervalMs);
    }

    function stop() {
      window.clearInterval(timer);
    }

    function setPaused(next) {
      paused = next;
      syncPause();
      if (paused) stop();
      else play();
    }

    pauseBtn?.addEventListener("click", () => setPaused(!paused));

    root.querySelector("[data-slideshow-prev]")?.addEventListener("click", () => {
      goTo(index - 1);
      play();
    });
    root.querySelector("[data-slideshow-next]")?.addEventListener("click", () => {
      goTo(index + 1);
      play();
    });
    dots.forEach((dot, i) => {
      dot.addEventListener("click", () => {
        goTo(i);
        play();
      });
    });

    let startX = 0;
    root.addEventListener("touchstart", (event) => {
      startX = event.changedTouches[0].clientX;
      stop();
    }, { passive: true });
    root.addEventListener("touchend", (event) => {
      const dx = event.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) goTo(index + (dx < 0 ? 1 : -1));
      play();
    });

    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", play);
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) stop();
      else play();
    });

    goTo(0);
    syncPause();
    play();
  });
})();
